let envConfig;

if (window.location.hostname.includes('weticket-prod.netlify.app') || window.location.hostname.includes('weticket.co.za') || process.env.ENV === 'PROD') {

  envConfig = {
    name: 'Production',
    uiHost: 'https://weticket.co.za/',
    apiHost: 'https://api.weticket.co.za/',
    assetBase: 'https://weticket.co.za/assets',
    paymentHost: 'https://weticket.co.za',
    peachCheckoutUrl: 'https://checkout.peachpayments.com/js/checkout.js',
  };
}
else if (process.env.ENV === 'QA') {

  envConfig = {
    name: 'QA',
    uiHost: 'https://weticket-dev.netlify.app/',
    apiHost: 'https://weticket-api-dev-791836476647.us-central1.run.app/',
    assetBase: 'https://weticket-dev.netlify.app/assets',
    paymentHost: 'https://weticket-dev.netlify.app',
    peachCheckoutUrl: 'https://sandbox-checkout.peachpayments.com/js/checkout.js',
  };
}
else {

  envConfig = {
    name: 'Development',
    uiHost: 'http://localhost:3000/',
    apiHost: 'http://localhost:8080/',
    assetBase: 'http://localhost:3000/assets',
    paymentHost: 'http://localhost:3000',
    peachCheckoutUrl: 'https://sandbox-checkout.peachpayments.com/js/checkout.js',
  };
}

export const Environment = envConfig;